import { useEffect } from 'react';
import { postMessage } from '../helpers/utils';
import { useSimulationContext } from '../providers/SimulationProvider';
import {
  MESSAGE_TYPES,
  SIMULATION_TYPES,
  VAD_STATES,
  VOICE_MODE_STATUS
} from '../constants/simulationConstants';

function useVoiceModeListener() {
  const {
    isAiTalking,
    isClientInitialized,
    setIsDebugVad,
    simulationType,
    setIsUserInterrupt,
    setIsVoiceModeActive
  } = useSimulationContext();

  useEffect(() => {
    if (!isClientInitialized) return;
    postMessage({
      type: MESSAGE_TYPES.VOICE_MODE,
      payload: {
        status: VOICE_MODE_STATUS.INACTIVE
      }
    });
  }, [isClientInitialized]);

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        let receivedData = event.data;

        // Parse JSON if string
        if (typeof receivedData === 'string') {
          try {
            receivedData = JSON.parse(receivedData);
          } catch (err) {
            return;
          }
        }

        // Only handle VOICE_MODE messages for Basic simulation
        if (
          receivedData.type !== MESSAGE_TYPES.VOICE_MODE ||
          !isClientInitialized ||
          simulationType !== SIMULATION_TYPES.BASIC
        ) {
          return;
        }

        const { isEnable, isUserInterrupt, isDebugVad } =
          receivedData.payload || {};

        // Handle voice mode enable/disable
        if (typeof isEnable === 'boolean') {
          setIsVoiceModeActive(isEnable);

          // Send status back to parent
          postMessage({
            type: MESSAGE_TYPES.VOICE_MODE,
            payload: {
              status: isEnable
                ? VOICE_MODE_STATUS.ACTIVE
                : VOICE_MODE_STATUS.INACTIVE
            }
          });
        }

        // Handle user interrupt
        if (typeof isUserInterrupt === 'boolean' && isAiTalking) {
          setIsUserInterrupt(isUserInterrupt);
          postMessage({
            type: MESSAGE_TYPES.VOICE_MODE,
            payload: {
              status: VAD_STATES.IDLE
            }
          });
        }

        // Handle user interrupt
        if (typeof isVadDebug === 'boolean') {
          const message = isDebugVad ? 'Enabled' : 'Disabled';
          console.log('[Debug VAD]', message);
          setIsDebugVad(isDebugVad);
        }
      } catch (error) {
        console.error('[Voice Mode Listener Error]:', error);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClientInitialized, simulationType, isAiTalking]);
}

export default useVoiceModeListener;
